import type { Plugin } from 'vue'
import PrimeVue from "primevue/config";
import ToastService from 'primevue/toastservice';
import { createVfm } from 'vue-final-modal'

export const UIKitPlugin: Plugin = {
  install(app) {
    app.use(createVfm())
    app.use(PrimeVue)
    app.use(ToastService);
  },
};